import { render, staticRenderFns } from "./HeaderWechatPopover.vue?vue&type=template&id=7a6f5d05&scoped=true"
import script from "./HeaderWechatPopover.vue?vue&type=script&lang=js"
export * from "./HeaderWechatPopover.vue?vue&type=script&lang=js"
import style0 from "./HeaderWechatPopover.vue?vue&type=style&index=0&id=7a6f5d05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6f5d05",
  null
  
)

export default component.exports